module.exports = __webpack_public_path__ + "static/media/favicon.6aa3282c.webp";